/**
 * Copyright (C), 2012-2020, Sichuan Xiaoka Technology Co., Ltd.
 * 登录相关处理
 * */
import Vue from 'vue'
import router from '../../router/index'
import axiosMethods from '../../axios/axios-methods'

const state = {
    userInfoGetter: {},
    buttons: null,
    permissions: '',
    cityList: [],
    allCityList: []
};

const mutations = {
    muLogin(state, data) {
        state.userInfoGetter = data;
        sessionStorage.setItem('userInfo', JSON.stringify(data));
    },
    muCheckLogin(state) { // 检查登录
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        if (userInfo && userInfo.token) {
            state.userInfoGetter = userInfo
            setTimeout(() => {
                // 等待菜单加载完成再调用
                this.dispatch('acAssignVoice')
            }, 1000);
        } else {
            // H5页面不需要登录，不跳转
            const currentPath = window.location.hash.replace('#', '')
            if (!currentPath.startsWith('/h5/')) {
                this.dispatch('acLogout')
            }
        }
    },
    muLogout(state) { // 退出登录
        if (state.userInfoGetter && state.userInfoGetter.appKey) {
            Vue.prototype.$mqtt.cancelTopic({
                tpc: '/bus/admin/' + state.userInfoGetter.appKey,
                opt: {
                    qos: 1
                }
            });
            Vue.prototype.$mqtt.cancelTopic({
                tpc: '/bus/organization/' + state.userInfoGetter.appKey,
                opt: {
                    qos: 1
                }
            });
        }

        state.userInfoGetter = {};
        sessionStorage.removeItem('userInfo');
        router.push('/login')
    },
    // 权限id
    muPermissions(state, permissions) {
        state.permissions = permissions;
    },
    // 权限id
    muButtons(state, buttons) {
        state.buttons = buttons;
    },
    muCityList(state, cityList) {
        state.cityList = cityList;
        state.allCityList = [
            {
              gaodeCityCode: null,
              cityName: "全部城市",
              value: null,
              label: "全部城市",
            },
            ...cityList,
          ];
    },
};

const getters = {
    userInfoGetter: state => state.userInfoGetter,
    buttonsGetter: state => state.buttons,
    permissionsGetter: state => state.permissions,
    cityListGetter: state => state.cityList,
    allCityListGetter: state => state.allCityList,
};

const actions = {
    acLogin({commit}, data) { // 登录
        commit('muLogin', data);
        commit('muPermissions', data.permissions)
        setTimeout(() => {
            this.dispatch('acAssignVoice')
        }, 1);
    },
    acCheckLogin({commit}) { // 检查登录
        commit('muCheckLogin')
    },
    async acLogout({commit, state}) { // 退出登录
        // 静默调用后端 logout，销毁 Redis Session（即使失败也继续本地退出）
        try {
            const token = state.userInfoGetter && state.userInfoGetter.token
            if (token) {
                await axiosMethods.postAxios('/api/v1/manage/login/logout', {})
            }
        } catch (e) {
            // 退出接口失败不影响本地退出流程
        }
        commit('muAssignVoice', false, {root: true})
        commit('muLogout')
    },
    acPermissions({commit}, permissions) { // 权限id
        commit('muPermissions', permissions)
    },
    acButtons({commit}, buttons) { // 权限id
        commit('muButtons', buttons)
    },
};

export default {
    name: 'login',
    state,
    mutations,
    getters,
    actions
}
